import React, { useState } from 'react';
import { cleanseInput } from 'src/ui/util';
import { composeValidators, number, email } from 'src/ui/validations';
;;
import { Button, Columns, Column, Control } from 'src/ui/mui-ui-kit';;
import { Form, Field } from 'react-final-form';
import {
  UiInputAdapter,
  UiToggleAdapter,
  UiSelectAdapter,
  ConfirmChangesModal,
} from 'src/ui';
import propTypes from 'prop-types';
import { COMPLIANCE_TASK_FREQUENCY as TASK_FREQUENCY } from '../const';
/* eslint-disable react/jsx-no-bind */
// const TASK_FREQUENCY = [
//   {
//     value: 0,
//     label: 'Daily',
//   },
//   {
//     value: 1,
//     label: 'Weekly',
//   },
// ];

export const EditAllComplianceForm = ({
  data,
  type,
  emailList,
  title,
  handleSubmitAll,
}) => {
  const [enableAll, setEnableAll] = useState(false);
  const [disableAll, setDisableAll] = useState(false);
  const [handleChange, setHandleChange] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [formData, setFormData] = useState({});

  function handleSubmit(data, form) {
    setFormData(data);
    form.reset();
    setEnableAll(false);
    setDisableAll(false);
    setHandleChange(false);
    setShowConfirm(true);
  }
  async function handleConfirm() {
    setShowConfirm(false);
    handleSubmitAll(formData, type);
  }

  return (
    <>
      <ConfirmChangesModal
        isActive={showConfirm}
        title={
          !formData.enableAll
            ? `${title}'s for ${data.length} account(s)`
            : `${title}'s for ALL active accounts`
        }
        onClickCancel={() => setShowConfirm(false)}
        onClickSubmit={handleConfirm}
      />
      <Form
        onSubmit={handleSubmit}
        enableAll={enableAll}
        disableAll={disableAll}
        setEnableAll={setEnableAll}
        setDisableAll={setDisableAll}
        handleChange={handleChange}
        setHandleChange={setHandleChange}
        emailList={emailList}
        type={type}
        subscription={{
          hasValidationErrors: false,
        }}
        mutators={{
          cleanse: ([event, cleansing], state, { changeValue }) => {
            cleanseInput(event, state, changeValue, cleansing);
          },
        }}
        render={({
          handleSubmit,
          enableAll,
          setEnableAll,
          disableAll,
          setDisableAll,
          type,
          hasValidationErrors,
          handleChange,
          setHandleChange,
        }) => {
          return (
            <form
              onSubmit={(e, form) => handleSubmit(e, form)}
              onChange={() => setHandleChange(true)}
            >
              <Columns>
                <Column isSize="1/3">
                  <Field
                    component={UiToggleAdapter}
                    type="checkbox"
                    id={`enableAll${type}`}
                    name="enableAll"
                    disabled={disableAll}
                    onClick={() => setEnableAll(!enableAll)}
                  >
                    Enable For All Accounts
                  </Field>
                  <Field
                    component={UiToggleAdapter}
                    type="checkbox"
                    defaultValue={false}
                    id={`disableAll${type}`}
                    name="disableAll"
                    disabled={enableAll}
                    onClick={() => setDisableAll(!disableAll)}
                  >
                    Disable For All Accounts
                  </Field>
                  {/* <Field
                    component={UiToggleAdapter}
                    type="checkbox"
                    defaultValue={false}
                    id={`addAllFIAdmin${type}`}
                    name="addAllFIAdmin"
                  >
                    Enable Emails for All Assigned Agents
                  </Field> */}
                </Column>
                <Column isSize="1/3">
                  {type !== 'Document' && (
                    <Field
                      component={UiSelectAdapter}
                      id={`taskFrequency${type}`}
                      type="dropdown"
                      name="taskFrequency"
                      label="Task Frequency"
                      options={TASK_FREQUENCY}
                      getOptionLabel={item => item.label}
                      getOptionValue={item => item.value}
                      onFocus={() => setHandleChange(true)}
                    />
                  )}
                  {type === 'Gratuity' && (
                    <Field
                      component={UiInputAdapter}
                      id="tolerance"
                      name="tolerance"
                      label="Gratuity Tolerance %"
                      validate={composeValidators(
                        'Gratuity Tolerance %',
                        number({ min: 0, max: 100, required: false })
                      )}
                    />
                  )}
                </Column>
                <Column isSize="1/3">
                  <Field
                    component={UiSelectAdapter}
                    name="addEmails"
                    id={`addEmails${type}`}
                    validate={composeValidators(
                      'Add Notification Email(s)',
                      email
                    )}
                    label="Add Notification Email(s)"
                    type="url"
                    isCreatable
                    components={{
                      DropdownIndicator: null,
                    }}
                    isMulti
                    placeholder="Type/paste and press enter..."
                    menuIsOpen={false}
                  />
                  <Field
                    component={UiSelectAdapter}
                    name="deleteEmails"
                    id={`deleteEmails${type}`}
                    label="Delete Email(s)"
                    isMulti
                    options={
                      emailList.map((email, idx) => ({
                        email,
                        idx,
                      })) || []
                    }
                    getOptionLabel={item => item.email}
                    getOptionValue={item => item.idx}
                    onFocus={() => setHandleChange(true)}
                  />
                </Column>
              </Columns>
              <Control>
                <Button
                  isColor="gradient-bright"
                  type="submit"
                  disabled={!handleChange || hasValidationErrors}
                >
                  Save
                </Button>
              </Control>
            </form>
          );
        }}
      />
    </>
  );
};

EditAllComplianceForm.propTypes = {
  data: propTypes.array.isRequired,
  type: propTypes.string.isRequired,
  emailList: propTypes.array.isRequired,
  title: propTypes.string.isRequired,
  handleSubmitAll: propTypes.func.isRequired,
};
